// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: var(--ion-color-secondary);
  background-size: cover !important;
  background-position: center bottom !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-image: url('home_bg.png') !important;
}

.payment-success-content .container {
  max-width: 720px;
  margin: 0 auto;
  padding: 16px 16px 20px;
  display: flex;
  flex-direction: column;
}

.logo-section {
  text-align: center;
}
.logo-section .brand-logo {
  width: 180px;
  height: 150px;
}

.success-card {
  background: var(--ion-color-secondary);
  padding: 18px 18px 22px;
  margin-bottom: 16px;
  border-radius: 8px;
}

.title-message {
  text-align: center;
  margin-bottom: 8px;
  padding-bottom: 12px;
}
.title-message h1 {
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  margin: 0;
  color: #000;
}

.thank-you-message {
  text-align: center;
  padding-bottom: 24px;
}
.thank-you-message h1 {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #666666;
  margin: 0;
}

.order-details {
  margin-bottom: 18px;
  padding: 14px 0;
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}
.order-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.order-details .detail-row:last-child {
  margin-bottom: 0;
}
.order-details .detail-row .detail-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  color: var(--color-dark-gray);
}
.order-details .detail-row .detail-label ion-icon {
  font-size: 16px;
  color: var(--color-dark-gray);
}
.order-details .detail-row .detail-value {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  color: var(--color-dark-gray);
  text-align: right;
}
.order-details .detail-row .detail-value .order-number {
  font-weight: 600;
}
.order-details .detail-row .chip-table {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  padding-inline: 6px;
  background-color: var(--ion-color-tertiary);
  border-radius: 4px;
  border: 1px solid var(--color-light-gray);
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-white);
}

.preparing-status {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #5c5c5c;
  font-size: 13px;
}
.preparing-status ion-spinner {
  width: 16px;
  height: 16px;
}

.download-receipt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #1d1d1b;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.download-receipt:hover {
  background: #1a1a1a;
}
.download-receipt span {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
}
.download-receipt ion-icon {
  width: 14px;
  height: 14px;
}

.order-items {
  margin-bottom: 16px;
}
.order-items .item-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}
.order-items .item-row .item-info {
  display: flex;
  gap: 8px;
  flex: 1;
}
.order-items .item-row .item-info .item-quantity {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-dark-gray);
}
.order-items .item-row .item-info .item-name {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  color: var(--color-dark-gray);
}
.order-items .item-row .item-price {
  font-family: "AppFont", sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-dark-gray);
  white-space: nowrap;
  margin-left: 16px;
}
.order-items .item-option {
  padding-left: 32px;
  margin-bottom: 8px;
  font-family: "AppFont", sans-serif;
  font-size: 11px;
  color: #5c5c5c;
}
.order-items .tip-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}

.miles-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}
.miles-row .miles-img {
  height: 18px;
  width: auto;
}
.miles-row .miles-value {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #226086;
}

.total-section {
  padding: 20px 0;
  border-top: 1px solid #e5e5e5;
}
.total-section .total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.total-section .total-row .total-label {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 14px;
  color: var(--color-dark-gray);
  text-transform: uppercase;
}
.total-section .total-row .total-amount {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 14px;
  color: var(--color-dark-gray);
}

.review-section {
  text-align: center;
}
.review-section .review-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  color: var(--ion-color-secondary);
  border-style: solid;
  border-radius: 2px;
  --background: var(--ion-color-primary);
  background: var(--ion-color-primary);
  outline: 1px solid var(--ion-color-secondary);
  outline-offset: var(--outline-offset-default);
  cursor: pointer;
  transition: background 0.2s;
  width: 100%;
  height: 44px;
}
.review-section .review-button ion-icon {
  font-size: 18px;
  color: var(--ion-color-tertiary);
}
.review-section .review-button .feedback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.review-section .review-button .feedback-container span {
  font-size: 12px;
  line-height: 15px;
  font-weight: 400;
  font-family: AppFontBold;
  color: var(--ion-color-tertiary);
}

.footer-message {
  text-align: center;
  margin-bottom: 16px;
  margin-top: auto;
}
.footer-message p {
  font-family: "AppFont", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #5c5c5c;
  margin: 0;
}

ion-footer {
  padding: 8px 20px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
ion-footer .final-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.01em;
  text-align: center;
  color: var(--color-white);
  margin-bottom: 12px;
}
ion-footer .new-order-button {
  height: 52px;
  width: 100%;
  padding: 0 16px;
  color: var(--ion-color-secondary);
  border-style: solid;
  border-radius: 2px;
  --background: var(--ion-color-primary);
  background: var(--ion-color-primary);
  outline: 1px solid var(--ion-color-secondary);
  outline-offset: var(--outline-offset-default);
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
ion-footer .new-order-button span {
  font-family: AppFont;
  font-size: 18px;
  font-weight: 400;
  color: var(--ion-color-secondary);
}
ion-footer .new-order-button ion-spinner {
  width: 24px;
  height: 24px;
  color: #fff;
}

@media (max-width: 768px) {
  .payment-success-content .container {
    height: 100%;
    padding: 16px 16px;
  }
  .success-card {
    padding: 24px 16px;
  }
  .logo-section .brand-logo {
    width: 180px;
  }
}
@media (max-width: 480px) {
  .detail-row {
    align-items: flex-start !important;
    gap: 8px;
  }
  .detail-row .detail-value {
    text-align: left !important;
  }
  .order-details .detail-row .detail-label {
    font-size: 13px;
  }
  .order-details .detail-row .detail-value {
    font-size: 13px;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-overlay ion-spinner {
  width: 48px;
  height: 48px;
  color: white;
}

.error-message {
  background: #ffebee;
  color: #c62828;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  text-align: center;
  font-family: "AppFont", sans-serif;
  font-size: 14px;
}

.status-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}
.status-tabs .status-tab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.status-tabs .status-tab .status-indicator {
  width: 100%;
  height: 10px;
  background: #e0e0e0;
  transition: background 0.3s ease;
}
.status-tabs .status-tab span {
  font-family: "AppFont", sans-serif;
  font-size: 13px;
  color: #9e9e9e;
  transition: color 0.3s ease;
}
.status-tabs .status-tab.active .status-indicator {
  background: #c6aa7a;
}
.status-tabs .status-tab.active span {
  color: #2c2c2c;
  font-weight: 600;
}
.status-tabs .status-tab:hover {
  opacity: 0.8;
}

.updated-price {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,sCAAA;EACA,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;AADD;;AAiBC;EACC,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AAdF;;AAmBA;EACC,kBAAA;AAhBD;AAkBC;EACC,YAAA;EACA,aAAA;AAhBF;;AAqBA;EACC,sCAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAlBD;;AAsBA;EACC,kBAAA;EACA,kBAAA;EACA,oBAAA;AAnBD;AAqBC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,SAAA;EACA,WAAA;AApBF;;AAyBA;EACC,kBAAA;EACA,oBAAA;AAtBD;AAwBC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAtBF;;AA2BA;EACC,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;AAxBD;AA0BC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAxBF;AA0BE;EACC,gBAAA;AAxBH;AA2BE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,eAAA;EACA,6BAAA;AAzBH;AA2BG;EACC,eAAA;EACA,6BAAA;AAzBJ;AA6BE;EACC,kCAAA;EACA,eAAA;EACA,6BAAA;EACA,iBAAA;AA3BH;AA6BG;EACC,gBAAA;AA3BJ;AA+BE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EAEA,2CAAA;EACA,kBAAA;EACA,yCAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AA/BH;;AAqCA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAlCD;AAoCC;EACC,WAAA;EACA,YAAA;AAlCF;;AAuCA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AApCD;AAsCC;EACC,mBAAA;AApCF;AAuCC;EACC,eAAA;EACA,gBAAA;EACA,WAAA;AArCF;AAwCC;EACC,WAAA;EACA,YAAA;AAtCF;;AA2CA;EACC,mBAAA;AAxCD;AA0CC;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAxCF;AA0CE;EACC,aAAA;EACA,QAAA;EACA,OAAA;AAxCH;AA0CG;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AAxCJ;AA2CG;EACC,kCAAA;EACA,eAAA;EACA,6BAAA;AAzCJ;AA6CE;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;AA3CH;AA+CC;EACC,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AA7CF;AAgDC;EACC,gBAAA;EACA,iBAAA;EACA,8BAAA;AA9CF;;AAmDA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAhDD;AAkDC;EACC,YAAA;EACA,WAAA;AAhDF;AAmDC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjDF;;AAsDA;EACC,eAAA;EACA,6BAAA;AAnDD;AAqDC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAnDF;AAqDE;EACC,wCAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;AAnDH;AAsDE;EACC,wCAAA;EACA,eAAA;EACA,6BAAA;AApDH;;AA0DA;EACC,kBAAA;AAvDD;AAyDC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,oCAAA;EACA,6CAAA;EACA,6CAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AAvDF;AAyDE;EACC,eAAA;EACA,gCAAA;AAvDH;AA0DE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAxDH;AA0DG;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,gCAAA;AAxDJ;;AA+DA;EACC,kBAAA;EACA,mBAAA;EACA,gBAAA;AA5DD;AA8DC;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA5DF;;AAgEA;EACC,sBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA9DD;AAgEC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AA/DF;AAkEC;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,oCAAA;EACA,6CAAA;EACA,6CAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhEF;AAkEE;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAhEH;AAmEE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAjEH;;AAuEA;EACC;IACC,YAAA;IACA,kBAAA;EApEA;EAuED;IACC,kBAAA;EArEA;EAwED;IACC,YAAA;EAtEA;AACF;AAyEA;EACC;IACC,kCAAA;IACA,QAAA;EAvEA;EAyEA;IACC,2BAAA;EAvED;EA2ED;IACC,eAAA;EAzEA;EA4ED;IACC,eAAA;EA1EA;AACF;AA8EA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA5ED;AA8EC;EACC,WAAA;EACA,YAAA;EACA,YAAA;AA5EF;;AAiFA;EACC,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AA9ED;;AAkFA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AA/ED;AAiFC;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;AA/EF;AAiFE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AA/EH;AAkFE;EACC,kCAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;AAhFH;AAoFG;EACC,mBAAA;AAlFJ;AAqFG;EACC,cAAA;EACA,gBAAA;AAnFJ;AAuFE;EACC,YAAA;AArFH;;AA0FA;EACC,gBAAA;AAvFD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:host {\n\tbackground: var(--ion-color-secondary);\n\tbackground-size: cover !important;\n\tbackground-position: center bottom !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-attachment: fixed !important;\n\tbackground-image: url('../../../assets/bistro/home_bg.png') !important;\n}\n\n.payment-success-content {\n\t// &::before {\n\t// \tcontent: '';\n\t// \tposition: fixed;\n\t// \ttop: 0;\n\t// \tleft: 0;\n\t// \tright: 0;\n\t// \tbottom: 0;\n\t// \tbackground: rgba(255, 255, 255, 0.65);\n\t// \tpointer-events: none;\n\t// \tz-index: 0;\n\t// }\n\n\t.container {\n\t\tmax-width: 720px;\n\t\tmargin: 0 auto;\n\t\tpadding: 16px 16px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n}\n\n// Logo Section\n.logo-section {\n\ttext-align: center;\n\n\t.brand-logo {\n\t\twidth: 180px;\n\t\theight: 150px;\n\t}\n}\n\n// Success Card\n.success-card {\n\tbackground: var(--ion-color-secondary);\n\tpadding: 18px 18px 22px;\n\tmargin-bottom: 16px;\n\tborder-radius: 8px;\n}\n\n// Title Message\n.title-message {\n\ttext-align: center;\n\tmargin-bottom: 8px;\n\tpadding-bottom: 12px;\n\n\th1 {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 12px;\n\t\tline-height: 150%;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\n\t\tmargin: 0;\n\t\tcolor: #000;\n\t}\n}\n\n// Thank You Message\n.thank-you-message {\n\ttext-align: center;\n\tpadding-bottom: 24px;\n\n\th1 {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 12px;\n\t\tfont-weight: 400;\n\t\tline-height: 1.5;\n\t\tcolor: #666666;\n\t\tmargin: 0;\n\t}\n}\n\n// Order Details Section\n.order-details {\n\tmargin-bottom: 18px;\n\tpadding: 14px 0;\n\tborder-bottom: 1px solid #e5e5e5;\n\tborder-top: 1px solid #e5e5e5;\n\n\t.detail-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 16px;\n\n\t\t&:last-child {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t.detail-label {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 8px;\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--color-dark-gray);\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: var(--color-dark-gray);\n\t\t\t}\n\t\t}\n\n\t\t.detail-value {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 12px;\n\t\t\tcolor: var(--color-dark-gray);\n\t\t\ttext-align: right;\n\n\t\t\t.order-number {\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\t\t.chip-table {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\theight: 22px;\n\t\t\tpadding-inline: 6px;\n\n\t\t\tbackground-color: var(--ion-color-tertiary);\n\t\t\tborder-radius: 4px;\n\t\t\tborder: 1px solid var(--color-light-gray);\n\n\t\t\tfont-family: AppFontBold;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n}\n\n// Preparing Status\n.preparing-status {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tcolor: #5c5c5c;\n\tfont-size: 13px;\n\n\tion-spinner {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n}\n\n// Download Receipt Button\n.download-receipt {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 6px 12px;\n\tbackground: #1d1d1b;\n\tcolor: white;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background 0.2s;\n\n\t&:hover {\n\t\tbackground: #1a1a1a;\n\t}\n\n\tspan {\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tcolor: #fff;\n\t}\n\n\tion-icon {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n\n// Order Items Section\n.order-items {\n\tmargin-bottom: 16px;\n\n\t.item-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: flex-start;\n\t\tmargin-bottom: 10px;\n\n\t\t.item-info {\n\t\t\tdisplay: flex;\n\t\t\tgap: 8px;\n\t\t\tflex: 1;\n\n\t\t\t.item-quantity {\n\t\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--color-dark-gray);\n\t\t\t}\n\n\t\t\t.item-name {\n\t\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: var(--color-dark-gray);\n\t\t\t}\n\t\t}\n\n\t\t.item-price {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: var(--color-dark-gray);\n\t\t\twhite-space: nowrap;\n\t\t\tmargin-left: 16px;\n\t\t}\n\t}\n\n\t.item-option {\n\t\tpadding-left: 32px;\n\t\tmargin-bottom: 8px;\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 11px;\n\t\tcolor: #5c5c5c;\n\t}\n\n\t.tip-row {\n\t\tmargin-top: 16px;\n\t\tpadding-top: 16px;\n\t\tborder-top: 1px dashed #e0e0e0;\n\t}\n}\n\n// Miles & More Section\n.miles-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 16px;\n\tpadding-top: 16px;\n\tborder-top: 1px dashed #e0e0e0;\n\n\t.miles-img {\n\t\theight: 18px;\n\t\twidth: auto;\n\t}\n\n\t.miles-value {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: #226086;\n\t}\n}\n\n// Total Section\n.total-section {\n\tpadding: 20px 0;\n\tborder-top: 1px solid #e5e5e5;\n\n\t.total-row {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.total-label {\n\t\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: var(--color-dark-gray);\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t.total-amount {\n\t\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: var(--color-dark-gray);\n\t\t}\n\t}\n}\n\n// Review Section\n.review-section {\n\ttext-align: center;\n\n\t.review-button {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tgap: 8px;\n\t\tpadding: 12px 24px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tborder-style: solid;\n\t\tborder-radius: 2px;\n\t\t--background: var(--ion-color-primary);\n\t\tbackground: var(--ion-color-primary);\n\t\toutline: 1px solid var(--ion-color-secondary);\n\t\toutline-offset: var(--outline-offset-default);\n\t\tcursor: pointer;\n\t\ttransition: background 0.2s;\n\t\twidth: 100%;\n\t\theight: 44px;\n\n\t\tion-icon {\n\t\t\tfont-size: 18px;\n\t\t\tcolor: var(--ion-color-tertiary);\n\t\t}\n\n\t\t.feedback-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\n\t\t\tspan {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tline-height: 15px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-family: AppFontBold;\n\t\t\t\tcolor: var(--ion-color-tertiary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Footer Message\n.footer-message {\n\ttext-align: center;\n\tmargin-bottom: 16px;\n\tmargin-top: auto;\n\n\tp {\n\t\tfont-family: 'AppFont', sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 1.5;\n\t\tcolor: #5c5c5c;\n\t\tmargin: 0;\n\t}\n}\n\nion-footer {\n\tpadding: 8px 20px 15px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.final-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 12px;\n\t\tline-height: 150%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-align: center;\n\t\tcolor: var(--color-white);\n\n\t\tmargin-bottom: 12px;\n\t}\n\t// New Order Button\n\t.new-order-button {\n\t\theight: 52px;\n\t\twidth: 100%;\n\t\tpadding: 0 16px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tborder-style: solid;\n\t\tborder-radius: 2px;\n\t\t--background: var(--ion-color-primary);\n\t\tbackground: var(--ion-color-primary);\n\t\toutline: 1px solid var(--ion-color-secondary);\n\t\toutline-offset: var(--outline-offset-default);\n\t\tcursor: pointer;\n\t\ttransition: background 0.2s;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\tspan {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 18px;\n\t\t\tfont-weight: 400;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\n\t\tion-spinner {\n\t\t\twidth: 24px;\n\t\t\theight: 24px;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n\t.payment-success-content .container {\n\t\theight: 100%;\n\t\tpadding: 16px 16px;\n\t}\n\n\t.success-card {\n\t\tpadding: 24px 16px;\n\t}\n\n\t.logo-section .brand-logo {\n\t\twidth: 180px;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.detail-row {\n\t\talign-items: flex-start !important;\n\t\tgap: 8px;\n\n\t\t.detail-value {\n\t\t\ttext-align: left !important;\n\t\t}\n\t}\n\n\t.order-details .detail-row .detail-label {\n\t\tfont-size: 13px;\n\t}\n\n\t.order-details .detail-row .detail-value {\n\t\tfont-size: 13px;\n\t}\n}\n\n// Loading State\n.loading-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 9999;\n\n\tion-spinner {\n\t\twidth: 48px;\n\t\theight: 48px;\n\t\tcolor: white;\n\t}\n}\n\n// Error State\n.error-message {\n\tbackground: #ffebee;\n\tcolor: #c62828;\n\tpadding: 12px 16px;\n\tborder-radius: 4px;\n\tmargin-bottom: 16px;\n\ttext-align: center;\n\tfont-family: 'AppFont', sans-serif;\n\tfont-size: 14px;\n}\n\n// Status Tabs\n.status-tabs {\n\tdisplay: flex;\n\tgap: 10px;\n\tmargin-bottom: 24px;\n\n\t.status-tab {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s ease;\n\n\t\t.status-indicator {\n\t\t\twidth: 100%;\n\t\t\theight: 10px;\n\t\t\tbackground: #e0e0e0;\n\t\t\ttransition: background 0.3s ease;\n\t\t}\n\n\t\tspan {\n\t\t\tfont-family: 'AppFont', sans-serif;\n\t\t\tfont-size: 13px;\n\t\t\tcolor: #9e9e9e;\n\t\t\ttransition: color 0.3s ease;\n\t\t}\n\n\t\t&.active {\n\t\t\t.status-indicator {\n\t\t\t\tbackground: #c6aa7a;\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tcolor: #2c2c2c;\n\t\t\t\tfont-weight: 600;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\topacity: 0.8;\n\t\t}\n\t}\n}\n\n.updated-price {\n\tmargin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
